import React from 'react'

import { Container, Row, Col } from 'react-bootstrap';
import { useGetAjwaProductsQuery } from '../../slices/productsApiSlice';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import Skeleton from 'react-loading-skeleton';

import Meta from '../../components/Meta';
import ShoppingProduct from '../../components/ShoppingProduct';

const SITE = 'https://tamratdates.com';

const FAQ_AR = [
  { q: 'أين تُزرع تمور العجوة؟', a: 'ترتبط العجوة بالمدينة المنورة، وتُعدّ من أكثر أنواع التمور تقديراً ومكانةً في السعودية.' },
  { q: 'ما الذي يميّز تمر العجوة؟', a: 'لونها الداكن وقوامها الطري وحلاوتها المعتدلة وطعمها العميق، إضافة إلى مكانتها التراثية والدينية المعروفة.' },
  { q: 'هل العجوة أقل حلاوة من السكري؟', a: 'نعم، حلاوتها أكثر اعتدالاً وطعمها أعمق، ويفضّلها كثيرون لهذا السبب.' },
  { q: 'هل العجوة مناسبة للإهداء؟', a: 'نعم، مكانتها وقيمتها تجعلانها من أرقى خيارات الإهداء، خاصة في المناسبات وللحجّاج والمعتمرين.' },
];
const FAQ_EN = [
  { q: 'Where are Ajwa dates grown?', a: 'Ajwa is associated with Madinah (Medina) and is among the most esteemed and prized date varieties in Saudi Arabia.' },
  { q: 'What makes Ajwa special?', a: 'Its dark colour, soft texture, balanced (milder) sweetness and deep flavour, along with its well-known heritage and cultural standing.' },
  { q: 'Is Ajwa less sweet than Sukari?', a: 'Yes — its sweetness is more moderate and its flavour deeper, which is exactly why many people prefer it.' },
  { q: 'Are Ajwa dates good for gifting?', a: 'Yes — their prestige and value make them one of the finest gifting choices, especially for special occasions and for pilgrims.' },
];

function AjwaDates() {

  const { t , i18n } = useTranslation();
  const en = i18n.language === 'en';

    const { data, isLoading, error } = useGetAjwaProductsQuery();

  const url = `${SITE}/ajwa-date`;
  const faq = en ? FAQ_EN : FAQ_AR;
  const schema = [
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: en ? 'Home' : 'الرئيسية', item: `${SITE}/` },
        { '@type': 'ListItem', position: 2, name: en ? 'Ajwa Dates' : 'تمر العجوة', item: url },
      ],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faq.map((f) => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    },
  ];

    if(isLoading) {
      return(
      <div>
   <div className='d-flex text-center align-items-center p-5 pb-0 gap-1 ml-5'>
   <Skeleton width={150} />
   </div>
      <h1 className="title">
         <Skeleton width={150} />
      </h1>
        <Row className="py-5">
        <Col sm={4} className="mb-2"><Skeleton height={250} width={350} /></Col>
        <Col sm={4} className="mb-2"><Skeleton height={250} width={350} /></Col>
        <Col sm={4} className="mb-2"><Skeleton height={250} width={350} /></Col>
        <Col sm={4} className="mb-2"><Skeleton height={250} width={350} /></Col>
        <Col sm={4} className="mb-2"><Skeleton height={250} width={350} /></Col>
        <Col sm={4} className="mb-2"><Skeleton height={250} width={350} /></Col>
        </Row>
    </div>
      )
    }

  return (
    <div>
      {en ? (
        <>
          <Meta
            title={'Ajwa Dates — Premium Madinah Ajwa | Tamrat'}
            description={'Buy premium Ajwa dates online from Tamrat — dark, soft, gently sweet dates from Madinah. Fast delivery across Saudi Arabia, free over 250 SAR.'}
            url={url}
            type={'website'}
            schema={schema}
          />
          <div className='d-flex text-center align-items-center p-5 pb-0 gap-1 ml-5'>
            <Link to={'/'}><span className='text-decoration-underline'>Home</span></Link>
            <FaAngleRight />
            <span style={{color:'#7C9D64'}}>Ajwa Date</span>
          </div>
        </>
      ) : (
        <>
          <Meta
            title={'تمر عجوة المدينة الأصلي — فاخر وطازج | تمرات'}
            description={'اشترِ تمر عجوة المدينة الفاخر من تمرات: داكن، طري، وحلاوة معتدلة وطعم عميق. توصيل سريع لكل مناطق السعودية وشحن مجاني للطلبات فوق ٢٥٠ ر.س.'}
            url={url}
            type={'website'}
            schema={schema}
          />
          <div className='d-flex text-center align-items-center p-5 pb-0 gap-1 ml-5'>
            <Link to={'/'}><span className='text-decoration-underline'>الرئيسية</span></Link>
            <FaAngleLeft />
            <span style={{color:'#7C9D64'}}>تمر العجوة</span>
          </div>
        </>
      )}

      <h1 className="title">{t('ajwaTitle')}</h1>
      <Container>
        <Row className="py-5">
        { error ? (
        <div>{error?.data.message || error.error}</div>
      ) : (
        data.products.map((product) => (
          <Col sm={4} key={product.id} className='mb-4 p-4'>
         <ShoppingProduct product={product} />
        </Col>
         ))
             )}
        </Row>
      </Container>

      <Container className="pb-5" dir={en ? 'ltr' : 'rtl'} style={{ maxWidth: 900, lineHeight: 1.9, color: '#3d3d3d' }}>
        {en ? (
          <div>
            <h2 style={{ color: '#7C9D64' }}>What is Ajwa?</h2>
            <p>Ajwa is one of Saudi Arabia's most esteemed dates, associated with <strong>Madinah</strong>. It is dark in colour, soft and fine in texture, with a balanced (milder) sweetness and a deep flavour. It carries a special heritage and cultural standing, and is widely chosen for hospitality, gifting, and as a treasured souvenir for pilgrims.</p>
            <h2 style={{ color: '#7C9D64' }}>How to enjoy Ajwa dates</h2>
            <ul>
              <li>With Arabic coffee, as a refined gesture of hospitality.</li>
              <li>As a gently sweet everyday bite.</li>
              <li>As an elegant gift for special occasions.</li>
              <li>As a meaningful souvenir from Hajj or Umrah.</li>
            </ul>
            <h2 style={{ color: '#7C9D64' }}>Nutrition</h2>
            <p>Ajwa dates are a natural source of energy, fibre and potassium. <em>Values are approximate and vary by size and ripeness; for any specific diet, consult a specialist.</em></p>
            <h2 style={{ color: '#7C9D64' }}>Who it's for</h2>
            <p>For those who prefer a deeper, more moderate sweetness, and for prestige gifting and special occasions.</p>
            <h2 style={{ color: '#7C9D64' }}>Frequently asked questions</h2>
            {FAQ_EN.map((f, i) => (<div key={i}><h3 style={{ fontSize: 18 }}>{f.q}</h3><p>{f.a}</p></div>))}
          </div>
        ) : (
          <div>
            <h2 style={{ color: '#7C9D64' }}>ما هي عجوة المدينة؟</h2>
            <p>العجوة من أعرق وأرقى أنواع التمور السعودية، وترتبط بـ<strong>المدينة المنورة</strong>. لونها داكن وقوامها طري ناعم، وحلاوتها معتدلة وطعمها عميق. تحظى بمكانة تراثية ودينية خاصة، ويقتنيها كثيرون للضيافة والإهداء، وكتذكار مميّز للحجّاج والمعتمرين.</p>
            <h2 style={{ color: '#7C9D64' }}>كيف تستمتع بتمر العجوة؟</h2>
            <ul>
              <li>مع القهوة العربية كضيافة راقية.</li>
              <li>قضمة يومية معتدلة الحلاوة.</li>
              <li>هدية أنيقة في المناسبات.</li>
              <li>تذكار مميّز من الحج أو العمرة.</li>
            </ul>
            <h2 style={{ color: '#7C9D64' }}>القيمة الغذائية</h2>
            <p>تمر العجوة مصدر طبيعي للطاقة والألياف والبوتاسيوم. <em>القيم تقريبية وتختلف حسب الحجم ودرجة النضج؛ ولأي نظام غذائي خاص يُنصح باستشارة مختص.</em></p>
            <h2 style={{ color: '#7C9D64' }}>لمن يناسب؟</h2>
            <p>لمن يفضّل الحلاوة المعتدلة والطعم العميق، وللإهداء الراقي والمناسبات الخاصة.</p>
            <h2 style={{ color: '#7C9D64' }}>الأسئلة الشائعة</h2>
            {FAQ_AR.map((f, i) => (<div key={i}><h3 style={{ fontSize: 18 }}>{f.q}</h3><p>{f.a}</p></div>))}
          </div>
        )}
      </Container>
    </div>
  )
}

export default AjwaDates
